import { render } from "./device-suspended.vue?vue&type=template&id=77672c36&scoped=true"
import script from "./device-suspended.vue?vue&type=script&lang=js"
export * from "./device-suspended.vue?vue&type=script&lang=js"

import "./device-suspended.vue?vue&type=style&index=0&id=77672c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77672c36"]])

export default __exports__